import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, SmsState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type SmsGetter = GetterTree<SmsState, RootState>

const state: SmsState = {
  /*
    BLOCS
  */
  smsBlocTexts: null,
  smsBlocText: null,
  /*
    SMS
  */
  smsCreditsLeft: null
}

export const getters: SmsGetter = {
  /*
    BLOCS
  */
  smsBlocTextsGetter: (state) => state.smsBlocTexts,
  smsBlocTextGetter: (state) => state.smsBlocText,
  smsCreditsLeftGetter: (state) => state.smsCreditsLeft
}

export const actions: ActionTree<SmsState, RootState> = {
  /*
    BLOCS
  */
  async getSmsBlocTextsAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/smsBloc`, {
      params: {
        ...queryParams
      }
    })
    commit('getSmsBlocTextsMutation', data)
    return data
  },
  async getSmsBlocTextByIdAction({commit}, id) {
    commit('resetSmsBlocTextMutation')
    const {data} = await axios.get(`${apiUrl}/smsBloc/${id}`)
    commit('getSmsBlocTextByIdMutation', data)
    return data
  },
  async createSmsBlocTextAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/smsBloc`, formParams)
    return data
  },
  async updateSmsBlocTextAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/smsBloc/${id}`, formParams)
    return data
  },
  async deleteSmsBlocTextAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/smsBloc/${id}`)
    return id
  },
  async syncSmsBlocTextAction({commit}, syncData) {
    const {data} = await axios.post(`${apiUrl}/smsBloc/sync`, {data: syncData})
    return data
  },
  /* SEND SMS */
  async sendSmsAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/sms`, formParams)
    return data
  },
  async getServiceNameSmsAction({commit}) {
    const {data} = await axios.get(`${apiUrl}/sms/serviceName`)
    commit('getServiceNameSmsMutation', data)
    return data
  }
}

const mutations: MutationTree<SmsState> = {
  /*
    BLOCS
  */
  getSmsBlocTextsMutation(state, data) {
    state.smsBlocTexts = data
  },
  getSmsBlocTextByIdMutation(state, data) {
    state.smsBlocText = data
  },
  getServiceNameSmsMutation(state, data) {
    state.smsCreditsLeft = data.creditsLeft
  },
  resetSmsBlocTextMutation(state) {
    state.smsBlocText = null
  }
}

export const sms: Module<SmsState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
